import * as actionTypes from '../constants/actionTypes';
import {ActionTypes as customerActionTypes} from '../actions/customers.js';
import {AccessRights} from '../schemas/accessRightsModel';
import customEvent from "../utilities/customEvent";


const initialState = {
  authenticated: false,
  userId: 0,
  customerId: 0,
  fabricatorId: 0,
  masterFabricatorId: 0,
  masterFabricatorIds: {},
  subDomain: '',
  managing: 'KitchenDB',
  userExistsIn: {'kitchen': false, 'bathroom': false},
  origUserExistsIn: {'kitchen': false, 'bathroom': false},
  doNotShowLinkWarning: false,
  roles: [],
  fabricatorLookups: {},
  pingPilotAuthToken: "",
};

const hasSub = (payload, tool) => {
  return (payload.roles && payload.roles[0] === "site.admin") || (payload.subscriptions[tool] && payload.subscriptions[tool].id > 0);
}

export function generateAuthState(state, payload) {
  const p = payload;
  AccessRights.get(state).setCurrentRoles(p.roles);
  return {
    ...state, authenticated: true, ...p, asCustomer: null, origUserExistsIn: {...payload.userExistsIn},
    hasKitchenSub: hasSub(p, "kitchen"),
    hasBathroomSub: hasSub(p, "bathroom"),
    hasFireplaceSub: hasSub(p, "fireplace"),
    hasLaundryRoomSub: hasSub(p, "laundryroom"),
    fabricatorLookups: payload.fabricatorLookups
  };
}

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {...state, managing: action.payload.manage};
    case actionTypes.LOGIN_COMPLETED:
      return generateAuthState(state, action.payload);
    case actionTypes.DO_NOT_SHOW_LINK_WARNING:
      return {...state, doNotShowLinkWarning: true};
    case customerActionTypes.APP_SET_AS_CUSTOMER:
      state.userExistsIn = {...state.origUserExistsIn};
      window.setTimeout(() => document.dispatchEvent(customEvent('reset-set-as')), 100);
      return state;
    case actionTypes.GET_PROTECTED_AREAS_BY_USER_RESPONSE:
      return {
        ...state,
        userExistsIn: {...action.payload.userExistsIn},
        hasKitchenSub: hasSub(action.payload, 'kitchen'),
        hasBathroomSub: hasSub(action.payload, 'bathroom'),
        hasFireplaceSub: hasSub(action.payload, 'fireplace'),
        hasLaundryRoomSub: hasSub(action.payload, 'laundryroom'),
        hasLeadFormSub: hasSub(action.payload, 'leadform'),
      };
    case actionTypes.LOGIN_REJECTED:
      return {...state, authenticated: false};

    case actionTypes.LOGOUT:
      return {...state, authenticated: false, userId: 0, customerId: 0, fabricatorId: 0, roles: [], asCustomer: null};
    default:
      return state;
  }
}
